/* src/app/components/common/field-editor/field-editor.component.scss */
.field-node {
  cursor: move;
  padding: 19px;
  display: flex;
  background: #fffdf8;
  justify-content: space-between;
  align-items: center;
  border-left: 2px solid #FFC107;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
}
.field-node:hover {
  background: #e8e8e8;
}
.field-node-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.field-node-section {
  padding: 19px;
  cursor: move;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border-left: 2px solid #223F92;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
}
.field-node-section:hover {
  background: #e8e8e8;
}
.field-node-section-items {
  min-height: 10px;
  padding-left: 30px;
}
.fa-chevron-down,
.fa-chevron-up,
.fa-pen-to-square,
.fa-check-to-slot,
.fa-input-text,
.fa-user-check {
  color: #223F92;
}
.actionText {
  color: #000000;
}
.childLabel {
  color: #000000;
}
:host-context(.dark-theme) .field-node-section {
  background: #464646;
}
:host-context(.dark-theme) .field-node-section:hover {
  background: rgba(255, 255, 255, 0.1882352941);
}
:host-context(.dark-theme) .field-node {
  background: #505050;
}
:host-context(.dark-theme) .field-node:hover {
  background: rgba(255, 255, 255, 0.1882352941);
}
:host-context(.dark-theme) .fa-chevron-down,
:host-context(.dark-theme) .fa-chevron-up,
:host-context(.dark-theme) .fa-pen-to-square,
:host-context(.dark-theme) .fa-check-to-slot,
:host-context(.dark-theme) .fa-input-text,
:host-context(.dark-theme) .fa-user-check {
  color: #88a3ff;
}
:host-context(.dark-theme) .action-text {
  color: white;
}
:host-context(.dark-theme) .child-label {
  color: white;
}
/*# sourceMappingURL=field-editor.component.css.map */
